import * as API from './api';

const QuickstartModel = { ...API };

export default QuickstartModel;
